import { Link } from 'react-router-dom';
import { S } from '../shared/studioTokens';

const CONTEXTS = [
  {
    to: '/size2mix',
    icon: 'bolt',
    label: 'Size2Mix',
    sub: 'Réseaux énergie · Optimisation · Production',
    accent: '#6366f1',
    accentBg: 'rgba(99,102,241,0.12)',
    accentBorder: 'rgba(99,102,241,0.3)',
  },
  {
    to: '/urbanmap',
    icon: 'map',
    label: 'Urban Map',
    sub: 'Carte territoire · Bâtiments · Prospection',
    accent: '#10b981',
    accentBg: 'rgba(16,185,129,0.12)',
    accentBorder: 'rgba(16,185,129,0.3)',
  },
  {
    to: '/plan2cost',
    icon: 'conversion_path',
    label: 'Plan',
    sub: 'Projets de plan de développement · Hypothèses · Scénarios',
    accent: '#00726d',
    accentBg: 'rgba(245,158,11,0.12)',
    accentBorder: 'rgba(245,158,11,0.3)',
  },
] as const;

export default function Landing() {
  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(135deg, ${S.bgDeep} 0%, #1e293b 60%, #1e3a5f 100%)`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'var(--nj-core-font-family-sans)',
      padding: '40px 24px',
    }}>
      {/* Logo / title */}
      <div style={{ textAlign: 'center', marginBottom: 56 }}>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 10,
          marginBottom: 14,
        }}>
          <span className="material-symbols-outlined" style={{ fontSize: 32, color: S.accentText }}>
            layers
          </span>
          <span style={{ fontSize: 28, fontWeight: 800, color: S.textPrimary, letterSpacing: '-0.5px' }}>
            Prototyper Studio
          </span>
        </div>
        <p style={{ fontSize: 15, color: S.textMuted, margin: 0, maxWidth: 400 }}>
          Choisissez un contexte pour accéder aux prototypes
        </p>
      </div>

      {/* Context cards */}
      <div style={{
        display: 'flex',
        gap: 20,
        flexWrap: 'wrap',
        justifyContent: 'center',
        maxWidth: 980,
        width: '100%',
      }}>
        {CONTEXTS.map((ctx) => (
          <Link
            key={ctx.to}
            to={ctx.to}
            style={{
              flex: '1 1 260px',
              maxWidth: 300,
              display: 'flex',
              flexDirection: 'column',
              gap: 16,
              padding: '28px 24px',
              borderRadius: 14,
              background: ctx.accentBg,
              border: `1px solid ${ctx.accentBorder}`,
              textDecoration: 'none',
              transition: 'transform 0.15s, box-shadow 0.15s',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = `0 8px 32px ${ctx.accentBg}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'none';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <div style={{
              width: 44, height: 44, borderRadius: 10,
              background: ctx.accentBg,
              border: `1px solid ${ctx.accentBorder}`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <span className="material-symbols-outlined" style={{ fontSize: 22, color: ctx.accent }}>
                {ctx.icon}
              </span>
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700, color: S.textPrimary, marginBottom: 4 }}>
                {ctx.label}
              </div>
              <div style={{ fontSize: 13, color: S.textMuted, lineHeight: 1.5 }}>
                {ctx.sub}
              </div>
            </div>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 4,
              fontSize: 12, fontWeight: 600, color: ctx.accent, marginTop: 'auto',
            }}>
              Ouvrir
              <span className="material-symbols-outlined" style={{ fontSize: 14 }}>arrow_forward</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
